// Session stash for "return to the row you came from" (NEA-6342): the product
// page writes the barcode as it navigates back, and the remounted Manage
// Products list consumes it once results load to scroll that row into view.
// sessionStorage rather than history state because the return trip is a
// `navigate(-1)` pop — the list's history entry carries no state of ours — and
// the consume-on-read keeps a later, unrelated visit from replaying the scroll.
const KEY = 'unify.manage-products.return-barcode';

export function stashReturnBarcode(barcode) {
	try {
		sessionStorage.setItem(KEY, barcode);
	} catch {
		// Storage unavailable (private browsing) — the return trip just skips the scroll.
	}
}

export function consumeReturnBarcode() {
	try {
		const barcode = sessionStorage.getItem(KEY);
		if (barcode) sessionStorage.removeItem(KEY);
		return barcode;
	} catch {
		return null;
	}
}
